import React from "react";

const RequiredMark = () => {
	return <span style={{ color: "#ba4545" }}>*</span>;
};

export default RequiredMark;
